import { cn } from '@savvy-kit/lib/utils';
import { isNil } from 'es-toolkit';

import type { TextCellContentProps } from '../../types/cell-types';

export function TextCellContent({ value, description, className }: TextCellContentProps) {
  return (
    <div className={cn('flex flex-col gap-0.5', className)}>
      <span className="text-sm text-dark">{value}</span>
      {!isNil(description) && <span className="text-xs text-secondary">{description}</span>}
    </div>
  );
}
